module.exports.PAYMENT_COMPLETED = "paid";
module.exports.PAYMENT_REQUESTED = "open";
module.exports.PAYMENT_ERROR = "failed";
module.exports.PAYMENT_REFUND = "chargeback";
module.exports.NOTIFICATION_LIST = "notification_list";
module.exports.AZC_LOGIN_SUCCESS = "azc_login_success";
module.exports.AZC_LOGIN_ERROR = "azc_login_error";
